const LICENSE_STATE_STORAGE_KEY = 'license_state';
const LICENSE_STATE_UPDATED_EVENT = 'license-state-updated';
const DEFAULT_LICENSE_BLOCKED_MESSAGE = 'Your license is invalid, expired, or out of grace period. Please contact support.';
const DEFAULT_LICENSE_BLOCKED_MESSAGE_DE = 'Ihre Lizenz ist ungültig, abgelaufen oder außerhalb der Kulanzfrist. Bitte kontaktieren Sie den Support.';

function resolveLicenseBlockedMessage(serverMessage, preferredLanguage = 'de') {
  const isGerman = String(preferredLanguage || 'de').toLowerCase().startsWith('de');

  if (isGerman) {
    return DEFAULT_LICENSE_BLOCKED_MESSAGE_DE;
  }

  return serverMessage || DEFAULT_LICENSE_BLOCKED_MESSAGE;
}

function getLicenseState() {
  try {
    const raw = sessionStorage.getItem(LICENSE_STATE_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    return parsed;
  } catch (_) {
    return null;
  }
}

function setLicenseState(state) {
  try {
    if (state && typeof state === 'object') {
      sessionStorage.setItem(LICENSE_STATE_STORAGE_KEY, JSON.stringify(state));
    } else {
      sessionStorage.removeItem(LICENSE_STATE_STORAGE_KEY);
    }

    window.dispatchEvent(new CustomEvent(LICENSE_STATE_UPDATED_EVENT, { detail: state || null }));
  } catch (_) {
    // best effort only
  }
}

function clearLicenseState() {
  setLicenseState(null);
}

export {
  LICENSE_STATE_STORAGE_KEY,
  LICENSE_STATE_UPDATED_EVENT,
  resolveLicenseBlockedMessage,
  getLicenseState,
  setLicenseState,
  clearLicenseState,
};
